import { render, staticRenderFns } from "./OrderDocumentationTypes.vue?vue&type=template&id=04d47f4a"
import script from "./OrderDocumentationTypes.vue?vue&type=script&lang=js"
export * from "./OrderDocumentationTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports